import { TextKey } from '@mews-commander/enums';
import { getAlternativePayments } from '../../constants';
import { SectionProps } from '../../types';
import { FormSection } from './FormSection';

export const AlternativePayments = ({ options }: SectionProps) => (
    <FormSection
        items={getAlternativePayments()}
        prefix="alternativePayments"
        options={options}
        titleTextKey={TextKey.AlternativePaymentPlural}
    />
);
